import Svg, { ClipPath, Defs, Ellipse, G, Path, Rect } from 'react-native-svg'

export const CvvIcon = ({ height, width, color = '#d1e0ff' }: { height: any; width: any; color: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-CVV">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="CVV" clipPath="url(#clip-CVV)" accessible={false} tabIndex={-1}>
        <G id="Group_5" data-name="Group 5" transform="translate(-836 -387)" accessible={false} tabIndex={-1}>
          <Rect
            id="Rectangle_858"
            data-name="Rectangle 858"
            width="24"
            height="16"
            rx="2"
            transform="translate(840 395)"
            fill={color}
            accessible={false}
            tabIndex={-1}
          />
          <Rect
            id="Rectangle_860"
            data-name="Rectangle 860"
            width="24"
            height="3"
            transform="translate(840 398)"
            fill="#fff"
            accessible={false}
            tabIndex={-1}
          />
          <Rect
            id="Rectangle_861"
            data-name="Rectangle 861"
            width="9"
            height="1"
            transform="translate(842 404)"
            fill="#fff"
            accessible={false}
            tabIndex={-1}
          />
          <G id="Group_4" data-name="Group 4" transform="translate(-1)" accessible={false} tabIndex={-1}>
            <Ellipse
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="6.5"
              cy="6.5"
              r="6.5"
              transform="translate(855 399)"
              fill={color}
              accessible={false}
              tabIndex={-1}
            />
            <Path
              id="Path_271"
              data-name="Path 271"
              d="M.935,2.415l.335.83.66-.83h.64L1.5,3.67,2.135,5H1.53l-.42-.94L.35,5H-.3L.89,3.62l-.57-1.2Zm2.525,0,.335.83.66-.83H5.1L4.02,3.67,4.66,5h-.6l-.42-.94L2.875,5H2.23L3.415,3.62l-.57-1.2Zm2.525,0,.335.83.66-.83h.64L6.545,3.67,7.185,5H6.58l-.42-.94L5.4,5H4.755L5.94,3.62l-.57-1.2Z"
              transform="translate(858 402)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
